export default {
  async getToken(action) {
    action = action ?? 'LOGIN'
    let token = await grecaptcha.enterprise.execute(import.meta.env.VITE_RECAPTCHA_KEY, {
      action
    })
    return token
  }
}
